import { Component, inject } from '@angular/core';
import { DxLoadPanelModule } from 'devextreme-angular';
import { LoadingService } from 'svnxii-ng-shared/services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [DxLoadPanelModule, TranslateModule],
  styles: [
    `
      ::ng-deep .dx-overlay-wrapper .dx-loadpanel-wrapper {
        color: white !important;
      }

      ::ng-deep .dx-loadpanel-message {
        color: white !important;
      }

      ::ng-deep .dx-overlay-shader {
        background-color: rgba(0, 0, 0, 0.8) !important;
      }
    `,
  ],
  templateUrl: './global-loader.html',
})
export class GlobalLoaderComponent {
  loadingService = inject(LoadingService);
  private translate = inject(TranslateService);

  get loadingMessage(): string {
    return this.translate.instant('Loading');
  }
}
